module.exports = ".top-box-program-status-link {\r\n  cursor: pointer;\r\n}\r\n\r\n  .top-box-program-status-link:hover {\r\n    color: #4b80e0 !important;\r\n  }\r\n\r\n  h3 {\r\n    margin-top: 20px;\r\n    margin-bottom: 10px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/top-three-box/top-three-box.component.css
// module id = ./src/app/shared/components/top-three-box/top-three-box.component.css
// module chunks = main